import { Card, Divider, Empty, Select, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  convertAmoutToINRWithNotation,
  getLast6MonthsMerchantWiseAnalysis,
} from '../../../../Utils/utils';
import styles from './index.module.css';
import { logoBaseURL } from '../../../../Utils/constants';
const Merchant: React.FC<{
  viewAll: () => void;
  isViewAll?: boolean;
  setViewAll?: () => void;
  txnType: string;
  currentMonthYearProps: string;
}> = ({
  viewAll,
  isViewAll = false,
  setViewAll,
  txnType,
  currentMonthYearProps,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  const [initalData, setInitialData] = useState<any>([]);
  const [currentMonthYear, setCurrentMonthYear] = useState<any>(`72024`);
  const [lastMonthsDetails, setLastMonthDetails] = useState<any>([]);

  const getIntialData = () => {
    const result = getLast6MonthsMerchantWiseAnalysis();

    setInitialData(result.data);

    const localFilterData = result.data.filter((element: any) => {
      if (
        `${element.month}${element.year}` === currentMonthYear &&
        (txnType === 'totalDebitAmount'
          ? element.totalDebitAmount > 0
          : element.totalCreditAmount)
      ) {
        return true;
      }
      return false;
    });

    if (txnType === 'totalDebitAmount') {
      const dataL = localFilterData.sort(
        (a: any, b: any) => b.totalDebitAmount - a.totalDebitAmount
      );

      setData(isViewAll ? dataL : dataL.slice(0, 4));
    } else {
      const dataL = localFilterData.sort(
        (a: any, b: any) => b.totalCreditAmount - a.totalCreditAmount
      );
      setData(isViewAll ? dataL : dataL.slice(0, 4));
    }

    setLastMonthDetails(result.Last6Months);

    setLoading(false);
  };

  // useEffect(() => {
  //   setLoading(true);

  //   const localFilterData = initalData.filter((element: any) => {
  //     if (
  //       `${element.month}${element.year}` === currentMonthYearProps &&
  //       (txnType === 'totalDebitAmount'
  //         ? element.totalDebitAmount > 0
  //         : element.totalCreditAmount)
  //     ) {
  //       return true;
  //     }
  //     return false;
  //   });

  //   if (txnType === 'totalDebitAmount') {
  //     setData(
  //       localFilterData
  //         .sort((a: any, b: any) => b.totalDebitAmount - a.totalDebitAmount)
  //         .slice(0, 4)
  //     );
  //   } else {
  //     setData(
  //       localFilterData
  //         .sort((a: any, b: any) => b.totalCreditAmount - a.totalCreditAmount)
  //         .slice(0, 4)
  //     );
  //   }

  //   setLoading(false);
  // }, [currentMonthYearProps]);

  useEffect(() => {
    setLoading(true);

    const monthFilter = isViewAll ? currentMonthYear : currentMonthYearProps;

    const localFilterData = initalData.filter((element: any) => {
      if (
        `${element.month}${element.year}` === monthFilter &&
        (txnType === 'totalDebitAmount'
          ? element.totalDebitAmount > 0
          : element.totalCreditAmount)
      ) {
        return true;
      }
      return false;
    });

    if (txnType === 'totalDebitAmount') {
      const dataL = localFilterData.sort(
        (a: any, b: any) => b.totalDebitAmount - a.totalDebitAmount
      );

      setData(isViewAll ? dataL : dataL.slice(0, 4));
    } else {
      const dataL = localFilterData.sort(
        (a: any, b: any) => b.totalCreditAmount - a.totalCreditAmount
      );
      setData(isViewAll ? dataL : dataL.slice(0, 4));
    }

    // setLastMonthDetails(result.Last6Months);

    setLoading(false);
  }, [currentMonthYear, txnType, currentMonthYearProps, isViewAll]);

  useEffect(() => {
    getIntialData();
  }, []);

  return (
    <Card
      className={styles.merchant_card}
      title={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography.Text
            style={{
              fontSize: '16px',
              fontWeight: '500',
            }}
          >
            Top merchants
          </Typography.Text>
          <Typography.Text
            style={{
              fontSize: '12px',
              color: `var(--primary-color)`,
              fontWeight: 'var(--font-medium)',
              cursor: 'pointer',
            }}
            onClick={() => {
              if (isViewAll) {
                setViewAll && setViewAll();
              } else {
                viewAll();
              }
            }}
          >
            {isViewAll ? 'Back' : 'View All'}
          </Typography.Text>
        </div>
      }
      loading={loading}
    >
      {isViewAll ? (
        <Select
          defaultValue='72024'
          style={{
            width: '100%',
            height: 50,
            borderRadius: 5,
            fontWeight: 600,
            border: '1px soild black',
          }}
          //   onChange={handleChange}
          id='selectionAccounts'
          title='Select Month'
          onChange={(e) => {
            setCurrentMonthYear(e);
          }}
          options={[
            { value: '72024', label: 'July 2024' },
            { value: '62024', label: 'June 2024' },
            { value: '52024', label: 'May 2024' },
            { value: '42024', label: 'April 2024' },
            { value: '32024', label: 'March 2024' },
            { value: '22024', label: 'February 2024' },
          ]}
        />
      ) : (
        <></>
      )}
      <div
        className={`${styles.merchant_list} ${
          isViewAll ? styles.merchant_listMargin : ''
        }`}
      >
        {data && data.length > 0 ? (
          data.map((merchant: any, index: number) => {
            return (
              <>
                <div className={styles.merchant_item}>
                  <div className={styles.merchant_info_div}>
                    <span className={styles.initials}>
                      <img
                        src={logoBaseURL + merchant.logo + '.jpg'}
                        height={28}
                      />
                    </span>{' '}
                    <div className={styles.merchant_info_details}>
                      <Typography.Text
                        className={styles.merchant_counterparty_text}
                      >
                        {merchant.counterParty}
                      </Typography.Text>
                      <Typography.Text style={{ fontSize: '10px' }}>
                        {txnType === 'totalDebitAmount'
                          ? merchant.totalDebitTxn
                          : merchant.totalCreditTxn}{' '}
                        {(
                          txnType === 'totalDebitAmount'
                            ? merchant.totalDebitTxn <= 1
                            : merchant.totalCreditTxn <= 1
                        )
                          ? 'transaction'
                          : 'transactions'}
                      </Typography.Text>
                    </div>
                  </div>
                  <Typography.Text style={{ fontWeight: '500' }}>
                    ₹
                    {convertAmoutToINRWithNotation(
                      txnType === 'totalDebitAmount'
                        ? merchant.totalDebitAmount
                        : merchant.totalCreditAmount
                    )}
                  </Typography.Text>
                </div>
                {index !== data.length - 1 && ( // Render Divider for all except the last item
                  <Divider
                    style={{
                      marginTop: '0',
                      marginBottom: '5px',
                    }}
                  />
                )}
              </>
            );
          })
        ) : (
          <>
            <Empty description={'No transaction found'} />
          </>
        )}
      </div>
    </Card>
  );
};

export default Merchant;
